import { Link, useParams } from 'react-router-dom'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../../hooks/useTitle'
import { useGetGradesQuery } from '../../actions/actionsApiSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import ResponseTextView from '../../../partial/ResponseTextView'
import ResponseCodeView from '../../../partial/ResponseCodeView'
import ResponseFileView from '../../../partial/ResponseFileView'
import AdditionListView from '../../../partial/AdditionListView'
import ReactQuill from 'react-quill'
import BooleansView from '../../../partial/BooleansView'
import StudentResponseGradeSteps from './StudentResponseGradeSteps'

const StudentGradeItem = () => {
    useTitle('geshtop-Exercise: Grade')

     const { actionId, groupId, type } = useParams()
    
     const {
        data: grades,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetGradesQuery('UserGradeList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false,
    })
    
    
    
    let content
    
    if (isLoading) content = <PulseLoader color={"#FFF"} />
    
    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    
    if (isSuccess) {
    const actionArray = grades?.filter(c=>c._id === actionId)
    if (!actionArray && !actionArray.length) return <PulseLoader color={"#FFF"} />

    const action = actionArray[0]
    const response = action.response
    const type = action?.type || "Text"

    const responseData = response && <>
     <StudentResponseGradeSteps response={response} />
        
               <span className='grid-results-header'> הערות בודק </span>
        <span className='grid-results-data'>
        <ReactQuill
                     theme='bubble'
                    readOnly
                    value={response.notes}
                    
                    ></ReactQuill>
           
            </span>
     <span className='grid-results-header'>בוצע בתאריך</span>
        <span className='grid-results-data'>{response.responseAt}</span>
        <span className='grid-results-header' >
            <div className='sticky'>ביצוע</div>
        </span>
        <span className='grid-results-data'>
          
        <>
                    {type==="Text"&& <ResponseTextView  body={response.body}  />}
                    {type==="Code"&& <ResponseCodeView  header={`${action?.title}-${action?.text}`} language={action?.language}  highlight={action?.highlight} body={response.body}  />}
                    {type==="File"&& <ResponseFileView  body={response.body}  />}
                  
                </>       
            </span>
        <AdditionListView additions={response.additions} type={type} />
        <BooleansView booleans={response.booleans} />

       
       
      
        {(response.friendsObj && response.friendsObj.length >0) &&<>
        <span className='grid-results-header'> עבדתן יחד?</span>
        <span className='grid-results-data'>{ response.friendsObj.map(friend=> ` ${friend.name}, `)}</span>
</>}
        <span className='grid-results-header'> הערות משתמש </span>
        <span className='grid-results-data'>
        <textarea readOnly
                    className={`form__input  form__input--comments  `}
                    id="comments"
                    name="comments"
                    value={response.comments}
                    
                />        
            </span>
            <span className='grid-results-header'> נבדק בתאריך</span>
        <span className='grid-results-data'>{response.gradeAt}</span>
        <span className='grid-results-header'>  ציון ע"י </span>
        <span className='grid-results-data'>{response.gradeByName}</span>
 
    </>
     content = 
     <>
     <Link to={`/${type}/${groupId}/my-grades`} className='icon-button'>
     <FontAwesomeIcon icon={faArrowAltCircleRight} />
     </Link>
        
     <div className='grid-results'>
        <span className='grid-results-header'>#</span>
        <span className='grid-results-data'>{action._id}</span>
        {action.groupName&&<><span className='grid-results-header'>קבוצה</span>
        <span className='grid-results-data'>{action.groupName}</span></>}
        <span className='grid-results-header'>משימה</span>
        <span className='grid-results-data'>{action.taskTitle}  </span>

        <span className='grid-results-header'>פירוט משימה</span>
        <span className='grid-results-data'>
        <ReactQuill
                     theme='bubble'
                    readOnly
                    value={action.taskBody}
                    
                    ></ReactQuill>
        </span>
        <span className='grid-results-header'> דרישה</span>
        <span className='grid-results-data'>{action.title} <hr />{action.text} {action.ratio? `(${action.ratio}%)`:""}</span>
        <span className='grid-results-header'> מצב ההגשה </span>
        <span className='grid-results-data'>    {response
        ? <span className="status--completed">DONE</span>
        : <span className="status--open">MISSING</span>
    } </span>
    
        <span className='grid-results-header'>ציון </span>
        <span className='grid-results-data'>
        {response?.grade > -1
                    ? <span className="status--completed">{response.grade} </span>
                    : <span className="status--open">לא ניתן ציון</span>
                    } 
            </span>
            {responseData}

       



     </div>
     </>
    }
    // const content =<>  <div >
    //             <h1>{action.taskName}</h1>
    //                 <address className="public__addr">
                  
    //                 </address>
    //             <br />
    //             <p>הזמן שנותר	</p>
               
    //         </div>
            
     //        </>
            

    return content
}
export default StudentGradeItem